module.exports = __webpack_public_path__ + "static/media/TestImage.7e9d39d1.PNG";